'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = localizedRead;

var _i18n = require('./i18n');

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function localizedRead(hash) {
  var fallbacks = [_i18n2.default.locale].concat(_i18n2.default.fallbacks[_i18n2.default.locale] || []);
  var localeWithValue = fallbacks.find(function (locale) {
    return hash[locale];
  });
  return localeWithValue ? hash[localeWithValue] : null;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/datocms-client/lib/utils/localizedRead.js
// module id = 129
// module chunks = 0